import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom';
import Loading from "react-fullscreen-loading";
import axios from 'axios';
import "../../../assets/css/single-policy.css";
import * as CONST from "../../../component/config/Constant"
import { Helmet } from "react-helmet";
import { FiArrowLeft, FiFileText, FiClock } from "react-icons/fi";

function Single() {
  const [loading, setloaing] = useState(false);
  const [policy, setPolicy] = useState("");
  const params = useParams();
  let slug = params.slug_id;
  let slug_name = params.slug_name;

  const fetchPolicyDetails = async (slug) => {
    await axios
      .get(CONST.WEB_GET_POLICY_DETAILS + slug)
      .then((response) => {
        const status = response.data.status;
        if (status === 'success') {
          setPolicy(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchPolicyDetails(slug);
  }, [slug])

  const capitalizeFirst = str => {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
  };

  const formatSlug = (str) => {
    return str?.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  };

  return (
    <div className='single-policy-page'>
      <Helmet>
        <title>{`${formatSlug(slug_name)} | eLuminous Technologies`}</title>
      </Helmet>
      <Loading
        loading={loading}
        background="rgba(0, 0, 0, 0.5)"
        loaderColor="#fff"
      />

      {/* Hero Banner */}
      <section className="policy-hero">
        <div className="container">
          <Link to="/" className="policy-back-link">
            <FiArrowLeft /> Back to Home
          </Link>
          {policy && policy.length > 0 && (
            <div className="policy-hero-content">
              <div className="policy-hero-title-row">
                <div className="policy-hero-icon">
                  <FiFileText />
                </div>
                <div>
                  <h1 className="policy-hero-title">{policy[0].policy_name}</h1>
                  <span className="policy-type-badge">
                    {policy[0].e_policy_type?.name || "Policy"}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Policy Content */}
      {policy && policy.map((p, index) => (
        <section className="policy-content-section" key={index}>
          <div className="container">
            <div className="row">
              {p.policy_image && (
                <div className="col-xl-4 col-lg-5 mb-4">
                  <div className="policy-image-card">
                    <img
                      src={CONST.HOST + p.policy_image_path}
                      alt={p.policy_name}
                      className="policy-feature-img"
                    />
                  </div>
                </div>
              )}
              <div className={p.policy_image ? "col-xl-8 col-lg-7" : "col-12"}>
                <div className="policy-body-card">
                  <div
                    className="policy-body-content"
                    dangerouslySetInnerHTML={{ __html: capitalizeFirst(p.policy_description) }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}
    </div>
  )
}

export default Single
